'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _defaultsDeep3 = require('lodash/defaultsDeep');

var _defaultsDeep4 = _interopRequireDefault(_defaultsDeep3);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var CropperFactory = null;

var Cropper = (_dec = (0, _reactI18next.translate)(['common'], { withRef: true }), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(Cropper, _Component);

  function Cropper() {
    var _ref;

    (0, _classCallCheck3.default)(this, Cropper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Cropper.__proto__ || (0, _getPrototypeOf2.default)(Cropper)).call.apply(_ref, [this].concat(args)));

    _this._setCropper = function (file) {
      var options = _this.props.options;

      var defaultOptions = {
        aspectRatio: 1,
        viewMode: 1,
        autoCropArea: 1,
        movable: false,
        rotatable: false,
        scalable: true, //important!
        zoomable: false,
        preview: '#' + _this.state.previewId
      };
      var cropperOptions = (0, _defaultsDeep4.default)(options, defaultOptions);

      if (_this.cropper) {
        _this.cropper.destroy();
      }

      _this.cropper = new CropperFactory(_this.coverImg, cropperOptions);
      _this.cropper.originalFile = file;
    };

    _this.state = {
      coverSrc: null,
      loading: false,
      fileName: 'image'
    };
    return _this;
  }

  (0, _createClass3.default)(Cropper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get3.default)(Cropper.prototype.__proto__ || (0, _getPrototypeOf2.default)(Cropper.prototype), 'componentDidMount', this).call(this, this.mountCropper);
    }
  }, {
    key: 'onImageSelected',
    value: function onImageSelected(e) {
      var _this2 = this;

      var reader = new FileReader();
      var file = e.target.files ? e.target.files[0] : null;

      reader.addEventListener('load', function () {
        _this2.setState({ coverSrc: reader.result });
        _this2._setCropper(file);
      }, false);

      if (file) {
        reader.readAsDataURL(file);
        this.setState({ fileName: file.name || 'image' });
      }
    }
  }, {
    key: 'mountCropper',
    value: function mountCropper() {
      CropperFactory = require('cropperjs').default;
      this.setState({ previewId: 'cropPreview' + Date.now() });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this.cropper) {
        this.cropper.destroy();
      }
      this.setState({
        coverSrc: null,
        loading: false
      });
    }
  }, {
    key: '_crop',
    value: function _crop() {
      if (!this.cropper) {
        return false;
      }
      this.setState({ loading: true });

      var _props = this.props,
          onCrop = _props.onCrop,
          width = _props.width,
          height = _props.height,
          fillColor = _props.fillColor;
      // this.cropper.getCroppedCanvas({fillColor: '#fff'}).toBlob((blob) => {
      //   this.uploader.methods.addFiles([blob]);
      // }, 'image/jpeg');

      var cropped = this.cropper.getCroppedCanvas({ width: width, height: height, fillColor: fillColor });

      if (onCrop) {
        // onCrop(cropped, this.state.fileName, this.cropper);
        onCrop(this.cropper.originalFile, cropped, this.state.fileName, this.cropper);
      }
    }
  }, {
    key: '_cancel',
    value: function _cancel() {
      this.setState({ coverSrc: null });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./Cropper.scss');
      var _state = this.state,
          isMounted = _state.isMounted,
          coverSrc = _state.coverSrc,
          loading = _state.loading,
          previewId = _state.previewId;
      var _props2 = this.props,
          className = _props2.className,
          cropperClassName = _props2.cropperClassName,
          t = _props2.t;


      return _react2.default.createElement(
        'div',
        null,
        isMounted && coverSrc && _react2.default.createElement(
          'div',
          { className: className },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('div', { id: previewId, className: styles.preview }),
            _react2.default.createElement(
              'div',
              { className: styles.cropper },
              _react2.default.createElement(
                'div',
                { className: cropperClassName },
                _react2.default.createElement('img', { src: coverSrc, ref: function ref(el) {
                    return _this3.coverImg = el;
                  }, className: styles.cropperImg, alt: '' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'margin-top-10 text-right' },
            loading ? _react2.default.createElement(_components.Loader, null) : _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'button',
                { type: 'button', className: 'btn btn-default', onClick: this._cancel },
                t('Cancel')
              ),
              _react2.default.createElement(
                'button',
                { type: 'button', className: 'btn btn-primary margin-left-10', onClick: this._crop },
                t('Save')
              )
            )
          )
        )
      );
    }
  }]);
  return Cropper;
}(_ClientSideComponent2.default), _class3.propTypes = {
  className: _propTypes2.default.string,
  cropperClassName: _propTypes2.default.string,
  fillColor: _propTypes2.default.string,
  height: _propTypes2.default.number,
  onCrop: _propTypes2.default.func,
  options: _propTypes2.default.object,
  t: _propTypes2.default.func.isRequired,
  width: _propTypes2.default.number
}, _class3.defaultProps = {
  fillColor: '#fff'
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'mountCropper', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'mountCropper'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_crop', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_crop'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_cancel', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_cancel'), _class2.prototype)), _class2)) || _class);
exports.default = Cropper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Cropper/Cropper.js
// module id = 1982
// module chunks = 1